import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { LookupForm } from "@/components/lookup-form";
import { QueryState } from "@/components/query-state";
import { UtxoTable } from "@/features/utxos/UtxoTable";
import { useGetAddressUtxosByAddress } from "@/generated/api/addresses/addresses";

export const Route = createFileRoute("/addresses")({ component: Addresses });

const FIELDS = [{ name: "address", label: "Address", placeholder: "addr1…" }] as const;

function Addresses() {
    const [address, setAddress] = useState<string | null>(null);

    return (
        <div className="space-y-4">
            <LookupForm fields={FIELDS} onSubmit={(values) => setAddress(values.address)} />
            {address && <AddressUtxos address={address} />}
        </div>
    );
}

function AddressUtxos({ address }: { address: string }) {
    const utxos = useGetAddressUtxosByAddress(address);
    return (
        <QueryState query={utxos} isEmpty={(data) => data.utxos.length === 0} emptyMessage="No UTXOs at this address.">
            {(data) => <UtxoTable utxos={data.utxos} label="Address UTXOs" />}
        </QueryState>
    );
}
